import axios from '@axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async sendEmail({ dispatch }, payload) {
    return axios.post('/api/email/send', payload)
  },
}
